import equalHeight from "./equalHeight";
import 'imagesloaded';

export default function addHightToImageGalery() {
  equalHeight();
  if ($(".info-gallery").is(":visible")) {
    $('.info-gallery').imagesLoaded().always(function () {
      $('.info-gallery:visible').each(function (index, el) {
        var $el = $(el);
        equalHeight($el.find('.product_item-img:visible'));
        equalHeight($el.find('.title:visible'));
      });
    });
  }
}